<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div *ngIf="isDeleting" class="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50">
  <div class="bg-white rounded-2xl p-8 shadow-xl flex flex-col items-center gap-3">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4"></p-progressSpinner>
    <span class="text-gray-600 font-medium">Eliminando...</span>
  </div>
</div>

<div class="min-h-screen bg-gray-50 p-6 flex flex-col gap-5">

  <div class="bg-white rounded-xl shadow-sm border border-gray-200 px-5 py-4 flex flex-wrap items-center gap-4">

    <div class="flex items-center gap-3 flex-1 min-w-0">
      <i class="pi pi-android text-blue-600 text-2xl flex-shrink-0"></i>
      <input
        pInputText
        [(ngModel)]="agentName"
        class="text-xl font-semibold bg-transparent border-0 border-b-2 border-transparent
               hover:border-gray-300 focus:border-blue-500 outline-none px-1 min-w-0 w-64 transition-colors" />
    </div>

    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-400">Estado:</span>
      <span class="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold" [ngClass]="statusBadgeClass">
        <span class="w-1.5 h-1.5 rounded-full" [ngClass]="statusDotClass"></span>
        {{ statusLabel }}
      </span>
    </div>

    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-400 whitespace-nowrap">Ambiente:</span>
      <div class="flex rounded-lg overflow-hidden border border-gray-200 text-xs font-semibold select-none">
        <button
          type="button"
          (click)="envMode = 'dev'; onEnvChange()"
          class="px-3 py-1.5 transition-colors"
          [ngClass]="envMode === 'dev'
            ? 'bg-amber-500 text-white'
            : 'bg-white text-gray-500 hover:bg-gray-50'">
          Dev
        </button>
        <button
          type="button"
          (click)="envMode = 'prod'; onEnvChange()"
          class="px-3 py-1.5 transition-colors border-l border-gray-200"
          [ngClass]="envMode === 'prod'
            ? 'bg-red-600 text-white'
            : 'bg-white text-gray-500 hover:bg-gray-50'">
          Prod
        </button>
      </div>
    </div>

    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-400 whitespace-nowrap">Tienda:</span>
      <p-select
        [options]="shops"
        [(ngModel)]="selectedShopId"
        optionLabel="name"
        optionValue="id"
        placeholder="Seleccione una tienda"
        (onChange)="onShopChange($event)"
        class="w-56">
      </p-select>
    </div>

    <button
      pButton
      type="button"
      label="Publicar cambios"
      icon="pi pi-upload"
      class="p-button-primary"
      [disabled]="true"
      pTooltip="Disponible próximamente"
      tooltipPosition="bottom">
    </button>
  </div>

  <div class="flex gap-5 items-start">

    <div class="flex-1 min-w-0">
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">

        <div class="px-5 pt-5 pb-3">
          <h2 class="text-base font-semibold text-gray-800 flex items-center gap-2">
            <i class="pi pi-book text-blue-600"></i>
            Base de conocimiento
          </h2>
          <p class="text-sm text-gray-400 mt-0.5">Enseña a tu agente cómo responder a tus clientes.</p>
        </div>

        <p-tabs value="conocimiento">
          <p-tablist>
            <p-tab value="conocimiento">
              <span class="flex items-center gap-2 text-sm">
                <i class="pi pi-pencil"></i> Agregar conocimiento
              </span>
            </p-tab>
            <p-tab value="documentos">
              <span class="flex items-center gap-2 text-sm">
                <i class="pi pi-file"></i> Documentos
              </span>
            </p-tab>
            <p-tab value="imagenes">
              <span class="flex items-center gap-2 text-sm">
                <i class="pi pi-image"></i> Imágenes
              </span>
            </p-tab>
          </p-tablist>

          <p-tabpanels>
            <p-tabpanel value="conocimiento">

            <div class="p-5">
              <div *ngIf="!selectedShopId" class="text-center py-14 bg-gray-50 rounded-xl">
                <i class="pi pi-shop text-5xl text-gray-200 mb-4 block"></i>
                <p class="text-gray-400">Seleccione una tienda para gestionar el conocimiento</p>
              </div>

              <div *ngIf="selectedShopId">
                <div class="flex items-center justify-between mb-4">
                  <p class="text-sm text-gray-500">
                    Bloques de conocimiento: preguntas frecuentes, procedimientos, políticas...
                  </p>
                  <button pButton type="button" label="Agregar conocimiento" icon="pi pi-plus"
                    class="p-button-success p-button-sm" (click)="openDialog()"></button>
                </div>

                <p-table
                  [value]="trainingEntries"
                  [paginator]="true"
                  [rows]="8"
                  [loading]="loading"
                  responsiveLayout="scroll"
                  styleClass="p-datatable-striped">

                  <ng-template pTemplate="header">
                    <tr>
                      <th class="bg-gray-50 text-gray-600 font-semibold text-sm">Categoría</th>
                      <th class="bg-gray-50 text-gray-600 font-semibold text-sm">Pregunta / Tema</th>
                      <th class="bg-gray-50 text-gray-600 font-semibold text-sm">Contexto</th>
                      <th class="bg-gray-50 text-gray-600 font-semibold text-sm w-36">Acciones</th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-entry>
                    <tr class="border-b border-gray-100 hover:bg-gray-50">
                      <td class="p-4">
                        <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full">
                          {{ entry.category }}
                        </span>
                      </td>
                      <td class="p-4 text-gray-700 text-sm">{{ entry.subject }}</td>
                      <td class="p-4 text-gray-500 text-sm max-w-xs">
                        <span class="line-clamp-2">{{ entry.context }}</span>
                      </td>
                      <td class="p-4">
                        <div class="flex gap-1">
                          <button pButton type="button" icon="pi pi-eye"
                            class="p-button-rounded p-button-info p-button-sm"
                            (click)="openPreview(entry)" pTooltip="Vista previa" tooltipPosition="top"></button>
                          <button pButton type="button" icon="pi pi-pencil"
                            class="p-button-rounded p-button-warning p-button-sm"
                            (click)="openDialog(entry)" pTooltip="Editar" tooltipPosition="top"></button>
                          <button pButton type="button" icon="pi pi-trash"
                            class="p-button-rounded p-button-danger p-button-sm"
                            (click)="deleteEntry(entry)" pTooltip="Eliminar" tooltipPosition="top"></button>
                        </div>
                      </td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="4" class="text-center p-10 text-gray-400">
                        <i class="pi pi-inbox text-4xl mb-3 block text-gray-300"></i>
                        No hay bloques de conocimiento. ¡Agrega el primero!
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
            </p-tabpanel>

            <p-tabpanel value="documentos">

            <div class="p-5 space-y-5">
              <div class="border-2 border-dashed border-gray-200 rounded-xl p-10 text-center bg-gray-50 opacity-60 select-none">
                <i class="pi pi-cloud-upload text-4xl text-gray-300 mb-3 block"></i>
                <p class="text-gray-500 font-medium mb-1">Arrastra tus documentos aquí</p>
                <p class="text-sm text-gray-400 mb-4">PDF, Word, Excel, URLs</p>
                <button pButton type="button" label="Seleccionar archivos" icon="pi pi-plus"
                  class="p-button-outlined p-button-secondary p-button-sm" [disabled]="true"></button>
              </div>

              <div>
                <p class="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-3">Documentos cargados</p>
                <div class="space-y-2">
                  <div *ngFor="let doc of mockDocuments"
                    class="flex items-center justify-between px-4 py-3 rounded-lg border border-gray-100 bg-gray-50 opacity-70">
                    <div class="flex items-center gap-3">
                      <i class="pi pi-file-pdf text-red-400 text-lg"></i>
                      <div>
                        <p class="text-sm font-medium text-gray-700">{{ doc.name }}</p>
                        <p class="text-xs text-gray-400">{{ doc.date }}</p>
                      </div>
                    </div>
                    <div class="flex items-center gap-3">
                      <span class="px-2 py-0.5 rounded-full text-xs font-semibold"
                        [ngClass]="doc.status === 'processed' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'">
                        {{ doc.status === 'processed' ? 'Procesado' : 'Pendiente' }}
                      </span>
                      <button pButton type="button" icon="pi pi-trash"
                        class="p-button-rounded p-button-text p-button-danger p-button-sm" [disabled]="true"></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </p-tabpanel>

            <p-tabpanel value="imagenes">

            <div class="p-5 space-y-5">
              <div class="border-2 border-dashed border-gray-200 rounded-xl p-10 text-center bg-gray-50 opacity-60 select-none">
                <i class="pi pi-images text-4xl text-gray-300 mb-3 block"></i>
                <p class="text-gray-500 font-medium mb-1">Sube imágenes para entrenar a tu agente</p>
                <p class="text-sm text-gray-400 mb-4">Manuales, diagramas, fotos de productos</p>
                <button pButton type="button" label="Seleccionar imágenes" icon="pi pi-plus"
                  class="p-button-outlined p-button-secondary p-button-sm" [disabled]="true"></button>
              </div>

              <div class="space-y-3">
                <div *ngFor="let img of mockImages"
                  class="flex items-start gap-4 p-4 rounded-lg border border-gray-100 bg-gray-50 opacity-70">
                  <div class="w-14 h-14 rounded-lg bg-gray-200 flex items-center justify-center flex-shrink-0">
                    <i class="pi pi-image text-gray-400 text-xl"></i>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="text-sm font-medium text-gray-700 mb-0.5">{{ img.name }}</p>
                    <p class="text-xs text-gray-400 italic">{{ img.description }}</p>
                  </div>
                  <button pButton type="button" icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger p-button-sm" [disabled]="true"></button>
                </div>
              </div>
            </div>
            </p-tabpanel>

          </p-tabpanels>
        </p-tabs>
      </div>
    </div>

    <div class="w-80 flex-shrink-0 flex flex-col gap-4">

      <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div class="px-4 py-3 border-b border-gray-100 bg-gray-50 flex items-center gap-2">
          <i class="pi pi-sliders-h text-purple-500"></i>
          <h3 class="text-sm font-semibold text-gray-700">Cómo responde la IA</h3>
        </div>
        <div class="p-4 space-y-4 opacity-60 select-none pointer-events-none">

          <div>
            <label class="text-xs font-semibold text-gray-400 uppercase tracking-widest block mb-2">Tono</label>
            <p-selectButton
              [options]="toneOptions"
              [(ngModel)]="selectedTone"
              optionLabel="label"
              optionValue="value"
              [disabled]="true"
              styleClass="w-full">
            </p-selectButton>
          </div>

          <div>
            <label class="text-xs font-semibold text-gray-400 uppercase tracking-widest block mb-2">Nivel de detalle</label>
            <p-selectButton
              [options]="detailOptions"
              [(ngModel)]="selectedDetailLevel"
              optionLabel="label"
              optionValue="value"
              [disabled]="true"
              styleClass="w-full">
            </p-selectButton>
          </div>

          <div>
            <label class="text-xs font-semibold text-gray-400 uppercase tracking-widest block mb-2">Restricciones</label>
            <div class="space-y-2">
              <div class="flex items-center gap-2">
                <p-checkbox [(ngModel)]="noInventar" [binary]="true" inputId="noInventar"></p-checkbox>
                <label for="noInventar" class="text-sm text-gray-600">No inventar información</label>
              </div>
              <div class="flex items-center gap-2">
                <p-checkbox [(ngModel)]="onlyDocuments" [binary]="true" inputId="onlyDocs"></p-checkbox>
                <label for="onlyDocs" class="text-sm text-gray-600">Responder solo con base en documentos</label>
              </div>
            </div>
          </div>

          <div>
            <label class="text-xs font-semibold text-gray-400 uppercase tracking-widest block mb-2">Idioma</label>
            <p-select
              [options]="languageOptions"
              [(ngModel)]="selectedLanguage"
              optionLabel="label"
              optionValue="value"
              [disabled]="true"
              class="w-full">
            </p-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showDialog"
  [header]="isEditMode ? 'Editar conocimiento' : 'Agregar conocimiento'"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
  [blockScroll]="isSaving">

  <div *ngIf="isSaving"
    class="absolute inset-0 bg-black/10 backdrop-blur-sm flex items-center justify-center rounded-lg z-50"
    style="position: absolute; inset: 0; border-radius: inherit;">
    <div class="bg-white rounded-full p-6 shadow-xl">
      <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="4"></p-progressSpinner>
    </div>
  </div>

  <form [formGroup]="form" (ngSubmit)="saveEntry()"
    [ngClass]="{ 'opacity-50 pointer-events-none blur-sm': isSaving }">
    <div class="grid grid-cols-12 gap-4">

      <div class="col-span-12">
        <label for="category" class="block mb-2 font-semibold text-gray-700">
          Categoría
        </label>
        <input id="category" pInputText formControlName="category" class="w-full"
          placeholder="Ej: Envíos, Pagos, Devoluciones" />
      </div>

      <div class="col-span-12">
        <label for="subject" class="block mb-2 font-semibold text-gray-700">
          Pregunta / Tema <span class="text-red-500">*</span>
        </label>
        <textarea id="subject" pTextarea formControlName="subject" class="w-full" rows="3"
          placeholder="Escriba la pregunta o consulta..."></textarea>
        <small class="text-red-500 text-sm"
          *ngIf="form.get('subject')?.invalid && form.get('subject')?.touched">Campo requerido</small>
      </div>

      <div class="col-span-12">
        <label for="context" class="block mb-2 font-semibold text-gray-700">
          Respuesta / Contexto <span class="text-red-500">*</span>
        </label>
        <textarea id="context" pTextarea formControlName="context" class="w-full" rows="5"
          placeholder="Escriba el contexto o respuesta..."></textarea>
        <small class="text-red-500 text-sm"
          *ngIf="form.get('context')?.invalid && form.get('context')?.touched">Campo requerido</small>
      </div>
    </div>

    <div class="flex justify-end gap-2 pt-4 mt-4 border-t border-gray-200">
      <button pButton type="button" label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="closeDialog()" [disabled]="isSaving"></button>
      <button pButton type="submit" [label]="isEditMode ? 'Actualizar' : 'Crear'" icon="pi pi-check"
        class="p-button-success" [disabled]="form.invalid || isSaving" [loading]="isSaving"></button>
    </div>
  </form>
</p-dialog>

<p-dialog
  [(visible)]="showPreviewDialog"
  header="Vista previa del conocimiento"
  [modal]="true"
  [style]="{ width: '45vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }">

  <div *ngIf="previewEntry" class="flex flex-col gap-4">
    <div class="flex items-center gap-2">
      <span class="text-xs font-semibold text-gray-400 uppercase tracking-widest">Categoría</span>
      <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 rounded-full">
        {{ previewEntry.category || '—' }}
      </span>
    </div>

    <div>
      <p class="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-1">Pregunta / Tema</p>
      <p class="text-sm font-medium text-gray-800">{{ previewEntry.subject }}</p>
    </div>

    <div>
      <p class="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-1">Contexto / Respuesta</p>
      <div class="bg-gray-50 border border-gray-200 rounded-lg p-4 text-sm text-gray-700 whitespace-pre-wrap leading-relaxed max-h-72 overflow-y-auto">
        {{ previewEntry.context }}
      </div>
    </div>
  </div>

  <div class="flex justify-end pt-4 mt-4 border-t border-gray-200">
    <button pButton type="button" label="Cerrar" icon="pi pi-times"
      class="p-button-text" (click)="showPreviewDialog = false"></button>
  </div>
</p-dialog>
